import { render } from "./SkeletonChurchUpdates.vue?vue&type=template&id=9c290482&scoped=true"
import script from "./SkeletonChurchUpdates.vue?vue&type=script&lang=js"
export * from "./SkeletonChurchUpdates.vue?vue&type=script&lang=js"

import "./SkeletonChurchUpdates.vue?vue&type=style&index=0&id=9c290482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c290482"]])

export default __exports__